import { useMemo } from 'react';
import { IDartsGamePlayer, IDartsTournament } from "../../../Darts/Games/DartsGamesCRUD.interface";
import { getSortedTournaments } from "../../../Tournaments/helpers/getSortedTournaments";
import { IDartsGroup } from "../../../Tournaments/TournamentsCRUD.types";
import { IdName } from "../../../../common/types/IdName";

interface IUseGetOptions {
    countries: IdName[];
    players: IDartsGamePlayer[];
    tournaments: IDartsTournament[];
    groups: IDartsGroup[]
    types: IdName []


}

const useGetOptions = ({countries, players, tournaments,groups,types}: IUseGetOptions) => {

    const countriesOptions = useMemo(() => {
        return countries.map((country) => ({
            key: country.id,
            value: country.id,
            text: country.name,
        }))
    }, [countries])

    const playersOptions = useMemo(() => {
        return players?.map((player) => ({
            key: player.id,
            value: player.id,
            text: player.name,
        }))
    }, [players])


    const tournamentsOptions = useMemo(() => {
        return getSortedTournaments(tournaments)?.map((tour) => ({
            key: tour.id,
            value: tour.id,
            text: tour.name,
        }))
    }, [tournaments])


    const groupOptions = useMemo(() => {
        return (groups)?.map((tour) => ({
            key: tour.id,
            value: tour.id,
            text: tour.name,
        }))
    }, [tournaments])

    const typesOptions = useMemo(() => {
        return (types)?.map((type) => ({
            key: type.id,
            value: type.id,
            text: type.name,
        }))
    }, [tournaments])

    return (
        {countriesOptions, playersOptions, tournamentsOptions,groupOptions,typesOptions}
    )

};

export default useGetOptions;
